module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.de8ad55b.svg";